(() => {
  function init(gallery){
  if(!gallery||gallery.dataset.dfInitialized)return;
  gallery.dataset.dfInitialized='true';
  const controller=new AbortController();
  const on=(node,event,handler,options={})=>node?.addEventListener(event,handler,{...options,signal:controller.signal});
  const listen=(node)=>({addEventListener:(event,handler,options)=>on(node,event,handler,options)});
  const panels=[...gallery.querySelectorAll('[data-gallery-panel]')],thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')],rail=gallery.querySelector('.v5-filmstrip');
  const previous=gallery.querySelector('[data-gallery-prev]'),next=gallery.querySelector('[data-gallery-next]'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const zoom=document.getElementById('zoom'),zoomImage=zoom.querySelector('img'),canvas=zoom.querySelector('.v5-zoom-canvas'),scale=zoom.querySelector('[data-zoom-scale]'),status=zoom.querySelector('[data-zoom-status]');
  let selected=0,zoomToken=0,zoomTrigger=null,touch=null;
  function loadImage(img){
    if(!img.dataset.src)return;
    img.loading='eager';
    if(img.dataset.srcset){img.srcset=img.dataset.srcset;delete img.dataset.srcset;}
    img.src=img.dataset.src;delete img.dataset.src;
  }
  function controls(){
    const current=panels[selected].querySelector('img');
    gallery.querySelector('[data-gallery-count]').textContent=String(selected+1).padStart(2,'0')+' / '+String(panels.length).padStart(2,'0');
    gallery.querySelector('[data-gallery-label]').textContent=current.dataset.label;
    previous.disabled=selected===0;next.disabled=selected===panels.length-1;
  }
  function select(index,{focus=false}={}){
    selected=Math.max(0,Math.min(panels.length-1,index));
    panels.forEach((panel,i)=>panel.hidden=i!==selected);
    thumbs.forEach((thumb,i)=>{thumb.setAttribute('aria-pressed',String(i===selected));thumb.tabIndex=i===selected?0:-1;});
    loadImage(panels[selected].querySelector('img'));controls();
    const thumb=thumbs[selected],left=thumb.offsetLeft-(rail.clientWidth-thumb.clientWidth)/2;
    rail.scrollTo({left:Math.max(0,left),behavior:reduced.matches?'instant':'smooth'});
    if(focus)thumb.focus({preventScroll:true});
  }
  thumbs.forEach((thumb,i)=>listen(thumb).addEventListener('click',()=>select(i)));
  listen(previous).addEventListener('click',()=>select(selected-1));listen(next).addEventListener('click',()=>select(selected+1));
  listen(rail).addEventListener('keydown',event=>{
    let index=selected;
    if(event.key==='ArrowRight')index++;
    else if(event.key==='ArrowLeft')index--;
    else if(event.key==='Home')index=0;
    else if(event.key==='End')index=panels.length-1;
    else return;
    event.preventDefault();select(index,{focus:true});
  });
  const stage=gallery.querySelector('.v5-gallery-stage');
  listen(stage).addEventListener('touchstart',event=>{if(event.touches.length===1)touch={x:event.touches[0].clientX,y:event.touches[0].clientY};else touch=null;},{passive:true});
  listen(stage).addEventListener('touchend',event=>{
    if(!touch)return;const dx=event.changedTouches[0].clientX-touch.x,dy=event.changedTouches[0].clientY-touch.y;touch=null;
    if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.3){select(selected+(dx<0?1:-1));stage.dataset.swiped='true';setTimeout(()=>delete stage.dataset.swiped,350);}
  },{passive:true});
  function fit(){canvas.classList.remove('is-original');scale.setAttribute('aria-pressed','false');scale.textContent=window.DFShopify.strings.zoomOriginal;canvas.scrollTo(0,0);}
  function displayZoom(){
    const img=panels[selected].querySelector('img'),token=++zoomToken;fit();
    zoom.querySelector('[data-zoom-count]').textContent=String(selected+1).padStart(2,'0')+' / '+String(panels.length).padStart(2,'0');
    zoom.querySelector('[data-zoom-label]').textContent=img.dataset.label;
    zoom.querySelector('[data-zoom-prev]').disabled=selected===0;zoom.querySelector('[data-zoom-next]').disabled=selected===panels.length-1;
    zoomImage.alt=img.alt;zoomImage.src=img.currentSrc||img.src;status.textContent=window.DFShopify.strings.zoomLoading;scale.disabled=true;
    const high=new Image();high.decoding='async';
    high.onload=()=>{if(token!==zoomToken||!zoom.open)return;zoomImage.src=high.src;scale.disabled=false;status.textContent='';};
    high.onerror=()=>{if(token===zoomToken&&zoom.open){scale.disabled=false;status.textContent=window.DFShopify.strings.zoomError;}};
    high.src=img.dataset.zoomSrc;
  }
  gallery.querySelectorAll('[data-zoom-index]').forEach(button=>listen(button).addEventListener('click',()=>{
    if(stage.dataset.swiped)return;
    selected=Number(button.dataset.zoomIndex);zoomTrigger=button;zoom.showModal();displayZoom();
  }));
  listen(scale).addEventListener('click',()=>{
    const original=canvas.classList.toggle('is-original');scale.setAttribute('aria-pressed',String(original));scale.textContent=original?window.DFShopify.strings.zoomFit:window.DFShopify.strings.zoomOriginal;
    status.textContent=original?window.DFShopify.strings.zoomPan:'';
    canvas.scrollTo(original?Math.max(0,(canvas.scrollWidth-canvas.clientWidth)/2):0,original?Math.max(0,(canvas.scrollHeight-canvas.clientHeight)/2):0);
  });
  function moveZoom(delta){select(selected+delta);displayZoom();}
  listen(zoom.querySelector('[data-zoom-prev]')).addEventListener('click',()=>moveZoom(-1));listen(zoom.querySelector('[data-zoom-next]')).addEventListener('click',()=>moveZoom(1));
  listen(zoom).addEventListener('keydown',event=>{if(canvas.classList.contains('is-original'))return;if(event.key==='ArrowRight'){event.preventDefault();moveZoom(1);}if(event.key==='ArrowLeft'){event.preventDefault();moveZoom(-1);}});
  listen(zoom).addEventListener('close',()=>{zoomToken++;zoomImage.removeAttribute('src');fit();(panels[selected].querySelector('button')||zoomTrigger)?.focus({preventScroll:true});});
  // Mouse drag pans the original; touch keeps native scrolling and browser pinch behavior.
  let drag=null;
  listen(canvas).addEventListener('pointerdown',event=>{
    if(event.pointerType!=='mouse'||!canvas.classList.contains('is-original'))return;
    event.preventDefault();drag={x:event.clientX,y:event.clientY,left:canvas.scrollLeft,top:canvas.scrollTop};canvas.setPointerCapture(event.pointerId);
  });
  listen(canvas).addEventListener('pointermove',event=>{if(drag){canvas.scrollLeft=drag.left+drag.x-event.clientX;canvas.scrollTop=drag.top+drag.y-event.clientY;}});
  listen(canvas).addEventListener('pointerup',()=>drag=null);listen(canvas).addEventListener('pointercancel',()=>drag=null);
  controls();
  on(document,'shopify:block:select',event=>{const thumb=event.target.closest('[data-gallery-thumb]');if(thumb&&gallery.contains(thumb))select(Number(thumb.dataset.galleryThumb));});
  on(document,'shopify:section:unload',event=>{if(event.target.contains(gallery)){zoomToken++;controller.abort();if(zoom.open)zoom.close();}});
  }
  const start=root=>{if(root.matches?.('[data-product-gallery]'))init(root);root.querySelectorAll('[data-product-gallery]').forEach(init);};
  start(document);document.addEventListener('shopify:section:load',event=>start(event.target));
})();
